export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20warm%20coral%20red%20and%20deep%20charcoal%20tones%2C%20soft%20gradient%20with%20geometric%20film%20strip%20patterns%2C%20elegant%20theater%20curtain%20textures%2C%20artistic%20motion%20blur%20effect%2C%20luxurious%20entertainment%20atmosphere%2C%20dark%20ambient%20lighting%20with%20subtle%20lens%20flares%2C%20premium%20cinema%20aesthetic&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/20"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-500/20 text-primary-300 rounded-full mb-4">
              每日更新
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight">
              人人影视
              <span className="block md:inline text-primary-400"> · 高清免费在线观看平台</span>
            </h1>
            <p className="mt-3 text-lg md:text-xl text-background-50/80 font-heading">
              不缓冲秒播 · 即点即看 · 海量免费
            </p>
            <p className="mt-4 text-sm md:text-base text-background-50/70 leading-relaxed max-w-xl mx-auto lg:mx-0">
              汇聚全球热门电视剧全集与电影大全，覆盖国产剧、美剧、韩剧、日剧、动漫等多元分类。高清画质免付费，极速加载不卡顿，每日同步更新最新剧集，为你打造一站式免费影视观看体验。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-background-50/80">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-sm">每日更新30+部</span>
              </div>
              <div className="flex items-center gap-2 text-background-50/80">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-sm">覆盖12大分类</span>
              </div>
              <div className="flex items-center gap-2 text-background-50/80">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-sm">免注册即看</span>
              </div>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-2.5 border border-background-50/30 text-background-50 font-medium text-sm rounded-md hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-timer-line text-lg"></i>
                最新更新
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20collage%20with%20overlapping%20movie%20scenes%2C%20warm%20lighting%20with%20coral%20and%20gold%20accents%2C%20dramatic%20composition%2C%20modern%20streaming%20platform%20visual%2C%20elegant%20layered%20design%20with%20depth%2C%20entertainment%20industry%20aesthetic%2C%20premium%20theater%20atmosphere%2C%20soft%20gradients%20between%20frames&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                alt="人人影视高清免费在线观看平台主视觉"
                className="w-full h-auto rounded-lg"
              />
              <div className="absolute inset-0 rounded-lg ring-1 ring-inset ring-background-50/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}